module.exports = __webpack_public_path__ + "static/media/carteFranceAvecPoints.8bedddcd.svg";